import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";
import { useEffect } from "react";
import type { ReactNode } from "react";
import App from "./App";
import "./index.css";
import i18n, { loadLanguageResources } from "./lib/i18n";

function LanguagePreference({ children }: { children: ReactNode }) {
  useEffect(() => {
    const url = new URL(window.location.href);
    if (
      url.searchParams.get("lang") === "en" ||
      url.searchParams.get("lang") === "tr"
    )
      return;

    const stored = window.localStorage.getItem("i18nextLng");
    const browser = window.navigator.language?.split("-")[0];
    const preferred =
      stored?.startsWith("tr") || browser === "tr" ? "tr" : "en";
    if (preferred !== i18n.language) void loadLanguageResources(preferred);
  }, []);

  return <>{children}</>;
}

async function boot() {
  const serverLanguage = document.documentElement.lang === "tr" ? "tr" : "en";
  await loadLanguageResources(serverLanguage);

  const app = (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <LanguagePreference>
          <App />
        </LanguagePreference>
      </I18nextProvider>
    </HelmetProvider>
  );

  const root = document.getElementById("root");
  if (!root) return;
  if (root.hasChildNodes()) hydrateRoot(root, app);
  else createRoot(root).render(app);
}

void boot();
